import React from "react";
import { ReactComponent as DefaultSVG } from "./media/default.svg";
import { ReactComponent as CheckedSVG } from "./media/checked.svg";
import { ReactComponent as ErrorSVG } from "./media/error.svg";
import { ReactComponent as GreenCheckedSVG } from "./media/green-checked.svg";

export const CIRCLE_STATES = {
  DEFAULT: "default",
  CHECKED: "checked",
  ERROR: "error",
  CHECKED_GREEN: "checked_green",
};

function getCircle(state) {
  switch (state) {
    case CIRCLE_STATES.CHECKED:
      return <CheckedSVG />;
    case CIRCLE_STATES.ERROR:
      return <ErrorSVG />;
    case CIRCLE_STATES.CHECKED_GREEN:
      return <GreenCheckedSVG />;
    case CIRCLE_STATES.CHECKED_GREEN:
      return <GreenCheckedSVG />;
    default:
      return <DefaultSVG />;
  }
}

function StatusCircle(props) {
  const { state, className } = props;
  return (<span className={`${className}`}>{getCircle(state)}</span>);
}

export default StatusCircle;
